import * as Comlink from 'comlink';
import type { AnalysisWorkerApi } from '../domain/types';

let apiPromise: Promise<Comlink.Remote<AnalysisWorkerApi>> | null = null;

export function getAnalysisWorker(): Promise<Comlink.Remote<AnalysisWorkerApi>> {
  if (!apiPromise) {
    apiPromise = new Promise((resolve, reject) => {
      const worker = new Worker(new URL('./analysis.worker.ts', import.meta.url), { type: 'module', name: 'sts2-analysis' });
      const api = Comlink.wrap<AnalysisWorkerApi>(worker);
      const timeout = setTimeout(() => {
        cleanup();
        worker.terminate();
        apiPromise = null;
        reject(new Error('分析模块初始化超时，请刷新页面后重试。'));
      }, 30_000);
      const cleanup = () => {
        clearTimeout(timeout);
        worker.removeEventListener('message', handleMessage);
        worker.removeEventListener('error', handleError);
      };
      const handleMessage = (event: MessageEvent<unknown>) => {
        if (!event.data || typeof event.data !== 'object' || (event.data as { type?: unknown }).type !== 'sts2-analysis-ready') return;
        cleanup();
        resolve(api);
      };
      const handleError = (event: ErrorEvent) => {
        cleanup();
        worker.terminate();
        apiPromise = null;
        reject(event.error instanceof Error ? event.error : new Error(event.message || '分析模块加载失败。'));
      };
      worker.addEventListener('message', handleMessage);
      worker.addEventListener('error', handleError);
    });
  }
  return apiPromise;
}

export async function hashText(text: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
  return [...new Uint8Array(digest)].map((value) => value.toString(16).padStart(2, '0')).join('');
}
